import { TFunction } from 'i18next';

export const RECORD_CONTACT_RECIPIENT = '__record_contact__';

const RECORD_CONTACT_MODELS: Record<string, string> = {
  'sale.order': 'sale_order',
  'stock.picking': 'stock_picking',
  'purchase.order': 'purchase_order',
  'project.task': 'project_task',
};

export const supportsRecordContact = (model?: string | null): boolean => !!model && model in RECORD_CONTACT_MODELS;

export const isRecordContactRecipient = (recipient?: string | null): boolean =>
  !recipient || recipient === RECORD_CONTACT_RECIPIENT;

export const recordContactLabel = (model: string | null | undefined, t: TFunction): string =>
  t(`workflows.record_contact.${(model && RECORD_CONTACT_MODELS[model]) || 'default'}`);
